import React from 'react';
import PropTypes from 'prop-types';
import { Html } from 'cccisd-wysiwyg';
import { Report, Page } from 'cccisd-laravel-report';
import { reportTemplatePlayer } from 'cccisd-laravel-appdefs';
import widgets from '../widgets.js';
import filterFields from '../filterFields.js';
import ReportHeader from '../../components/ReportHeader';
import style from './style.css';

const Component = props => {
    const {
        outcomesIndividualSummaryCallouts,
        outcomesIndividualSummaryChart,
        outcomesIndividualSummaryTable,
        outcomesIndividualComments,
        recommendations,
    } = props.widgets;

    const {
        body: { heading },
    } = props.settings;

    return (
        <Report>
            <Page>
                <div className={style.wrapper}>
                    <ReportHeader
                        settings={props.settings}
                        filters={props.filters}
                        isPreview={props.isPreview}
                        data={props.data}
                        individuals
                    />
                    <div className={style.reportBodyText}>
                        <Html content={heading} />
                    </div>
                    {outcomesIndividualSummaryCallouts}
                    {outcomesIndividualSummaryChart}
                    {outcomesIndividualSummaryTable}
                    {outcomesIndividualComments}
                    {recommendations}
                </div>
            </Page>
        </Report>
    );
};

Component.propTypes = {
    settings: PropTypes.object,
    isPreview: PropTypes.bool,
    filters: PropTypes.object,
    widgets: PropTypes.object,
    data: PropTypes.object,
};

export default reportTemplatePlayer({
    reportHandle: 'outcomes',
    userType: 'individuals',
    widgets,
    getFilterFields: props =>
        filterFields.map(field =>
            field.name === 'groupIds'
                ? {
                      ...field,
                      initialValue: props.data.groups.treatmentGroupList[0].childRoles.participantList
                          .map(pl => pl.pawn.pawnId)
                          .slice(0, 1),
                  }
                : field
        ),
})(Component);
